import { h, Component } from 'preact';
import style from './index.less'

export default (props)=>{
    let classes = [style.button]
    props.class && classes.push(props.class)
    return (
        <button class={classes.join(' ')} onClick={props.onClick} disabled={props.disabled}>
            {props.spinner? 
                <i class={`fa fa-spinner fa-spin`} aria-hidden="true"></i>
            :
                props.children
            }
        </button>
    )
}


// WEBPACK FOOTER //
// ./components/elements/Button/index.js